import { useRef, useState, useEffect } from 'react'
import DashboardContainer from 'components/smart/dashboard-container/DashboardContainer'
import AllRequestHeader from '../components/allRequestHeader'
import AllRequestContent from '../components/allRequestContent'
import { Typography, Box } from '@mui/material'
import { ChevronRight } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'

const AllRequest = () => {
  const navigate = useNavigate()
  const headerRef = useRef(null)
  const [tableHeight, setTableHeight] = useState()

  const handleBack = () => {
    navigate('../overview')
  }

  useEffect(() => {
    if (headerRef) {
      setTableHeight(headerRef.current.clientHeight)
    }
  }, [])
  return (
    <DashboardContainer
      headerTitle={
        <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
          <Typography onClick={handleBack} sx={{ cursor: 'pointer', color: 'alternate.main' }}>
            Leave Request
          </Typography>
          <ChevronRight sx={{ color: 'light-gray-text.main' }} />
          <Box>My Leave Request</Box>
        </Box>
      }
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <AllRequestHeader ref={headerRef} />
        <AllRequestContent />
      </Box>
    </DashboardContainer>
  )
}

export default AllRequest
